import React from 'react';
import {X7PushableBlock} from '../../../../domain';
import {TooltipBreadcrumb} from '../../../../lib/components';
import {routes} from '../../../../pages/Routes';

export class X7PushableBlockBreadcrumbs extends React.Component<{ pushableBlock: X7PushableBlock }> {
  render() {
    const {pushableBlock} = this.props;
    return (
      <div className="row" key="breadcrumbs">
        <div className="col">
          <div className="breadcrumb">
            <TooltipBreadcrumb tooltip="Languages"
                               label="Languages"
                               route={routes.X1LanguageList}/>

            <TooltipBreadcrumb tooltip="Language"
                               label={pushableBlock!.Page!.Lesson!.Unit!.Level!.AgeCategory!.Language!.Name}
                               route={routes.x1language(pushableBlock!.Page!.Lesson!.Unit!.Level!.AgeCategory!.LanguageId)}/>

            <TooltipBreadcrumb tooltip="Age Category"
                               label={pushableBlock!.Page!.Lesson!.Unit!.Level!.AgeCategory!.Name}
                               route={routes.x2ageCategory(pushableBlock!.Page!.Lesson!.Unit!.Level!.AgeCategoryId)}/>

            <TooltipBreadcrumb tooltip="Level"
                               label={pushableBlock!.Page!.Lesson!.Unit!.Level!.Name}
                               route={routes.x3level(pushableBlock!.Page!.Lesson!.Unit!.LevelId)}/>

            <TooltipBreadcrumb tooltip="Unit"
                               label={pushableBlock!.Page!.Lesson!.Unit!.Name}
                               route={routes.x4unit(pushableBlock!.Page!.Lesson!.UnitId)}/>

            <TooltipBreadcrumb tooltip="Lesson"
                               label={pushableBlock!.Page!.Lesson!.Name}
                               route={routes.x5lesson(pushableBlock!.Page!.LessonId)}/>

            <TooltipBreadcrumb tooltip="Page"
                               label={pushableBlock!.Page!.Name}
                               route={routes.x6page(pushableBlock!.PageId)}/>

            <TooltipBreadcrumb tooltip="Pushable block"
                               label={pushableBlock!.Name}
                               active/>
          </div>
        </div>
      </div>
    );
  }
}
